import React from 'react';
import PropTypes from 'prop-types';
import FormSection from '../../../../../../../../components/FormSection/FormSection';
import FieldList from '../../../../../../../../components/FieldList/FieldList';
import FormField from '../../../../../../../../components/FormField/FormField';
import GenericAjaxDropdown from '../../../../../../../../common/GenericAjaxDropdown/GenericAjaxDropdown';
import Address from '../../../../../../../../api/controllers/Company/Address/Address';
import AddressHelper from '../../../../../../../../utils/AddressHelper/AddressHelper';
import { faHome } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const onDisplayAddress = addr =>
  AddressHelper.formatAddress(AddressHelper.extractAddressToArray(addr, { postcodeFirst: true }), {
    dropdown: true,
  });

const BookingFormMisc = ({ data, alter, freightsoftAddress }) => {
  return (
    <FormSection title={'Miscellaneous'}>
      <div className={'space-fields'}>
        <FieldList>
          <FormField label={'Booking Date'}>
            <input
              type={'date'}
              data-testid={'bfg-booking-date'}
              value={data.bookingDate}
              onChange={e => alter('bookingDate', e.target.value)}
            />
          </FormField>

          <FormField label={'Warehouse'} className={'short'}>
            <div className={'button-input home'}>
              <button
                className={'home'}
                onClick={() => alter('warehouseAddress', freightsoftAddress)}
                disabled={!!data.freightsoftReference}
                data-testid={'bfm-warehouse-ital'}
              >
                <FontAwesomeIcon icon={faHome} />
              </button>
              <GenericAjaxDropdown
                value={data.warehouseAddress}
                call={Address.all}
                onSelect={wh => alter('warehouseAddress', wh)}
                onDisplay={onDisplayAddress}
                altParams={{ warehouse: true }}
                onClear={() => alter('warehouseAddress', null)}
                disabled={!!data.freightsoftReference}
              />
            </div>
          </FormField>
        </FieldList>
        <FormField label={'Additional Details'} className={'fill-80'}>
          <input
            data-testid={'bfg-additional-information'}
            value={data.additionalInformation}
            onChange={e => alter('additionalInformation', e.target.value)}
          />
        </FormField>
      </div>
    </FormSection>
  );
};

BookingFormMisc.propTypes = {
  data: PropTypes.object,
  alter: PropTypes.func,
  freightsoftAddress: PropTypes.object,
};

export default BookingFormMisc;
